
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Inventory } from '../../../backend/backendapi';
import InventoryStore from '../../../../stores/InventoryStore';
import { paginationOptions, searchOptions, selectOptions } from '../../../../util/vue-good-table';
import { Like } from '../../../../util/Like';

@Component({
  components: {
    VueGoodTable,
  },
})
export default class StockTakingEditModal extends Vue {
  readonly store = new InventoryStore();
  readonly selectedInventories: Inventory[] = [];

  public open(): void {
    this.store.loadIfAbsent();
    (this.$refs.table as VueGoodTable).reset();
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  get columnsConfig(): any[] {
    return [
      {
        label: 'Ident',
        field: 'ident',
      },
      {
        label: this.$t('txtInvName').toString(),
        field: 'name',
      },
      {
        label: this.$t('txtInvlocation').toString(),
        field: 'location',
      },
      {
        label: this.$t('txtInvOnStock').toString(),
        field: 'itemsOnStock',
      },
      {
        label: this.$t('txtInvSupplier').toString(),
        field: 'supplier',
      },
      {
        label: this.$t('txtInvGeneral').toString(),
        field: (i: Inventory) => i.generalInfo?.substring(0, 12),
      },
    ];
  };

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  get selectOptions(): any {
    return selectOptions(this.$i18n);
  }

  onSelectionChanged(params: { selectedRows: Like<Inventory>[] }): void {
    this.selectedInventories.splice(0);
    this.selectedInventories.push(...params.selectedRows);
  }
}
